

import { useState,useEffect } from "react";
import CountryDropdown from "../../molecule/CountryDropdown";
import WVLogo from "../../../images/wv-logo.svg"; 
import WVFranceLogo from "../../../images/wvlogoheader_login_fr.png";
import WVLogoWHRR from "../../../images/wv-logo-white-RR.png";
import { CenteredText } from "../../atoms/Common";
import WVLogoFin from "../../../images/finland_logo_white.png";





const CountrySelection = (props)=>{
  const [soDetails, setSoDetails]= useState(undefined);

  

  useEffect(() => {
    props?.setSoDetails(soDetails);
  }, [soDetails]);

  return (        

    <div className="ddContainer">
        <CenteredText logo>
          <img className="logo" src={soDetails?.soCode==="FRAO"?WVFranceLogo:soDetails?.soCode==="FINO" ? WVLogoFin : soDetails?.soCode==="NZLO"? WVLogoWHRR : WVLogo} alt="world vision logo"/>
        </CenteredText>
    
        
        <div className='countryDD'>
          <CountryDropdown setSoDetails={setSoDetails} />
        </div>
    </div>
  )
}

export default CountrySelection;